
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('🏠 首页加载，检查登录状态...');
    
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    
    console.log('📊 登录状态:', isLoggedIn);
    
    // 只在未登录时跳转到登录页，已登录用户停留在首页
    if (isLoggedIn !== 'true') {
      console.log('❌ 未登录，跳转到登录页');
      navigate('/login', { replace: true });
    } else {
      console.log('✅ 已登录，停留在首页');
    }
  }, [navigate]);

  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const userName = localStorage.getItem('userName') || '用户';

  if (!isLoggedIn) {
    // 未登录时显示加载状态，等待跳转
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
            <i className="ri-building-line text-2xl text-white"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">企业智能工作台</h2>
          <p className="text-gray-600 mb-4">正在加载...</p>
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-600 mx-auto"></div>
        </div>
      </div>
    );
  }

  // 已登录用户显示首页内容
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-building-line text-3xl text-white"></i>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">企业智能工作台</h1>
          <p className="text-xl text-gray-600 mb-2">欢迎回来，{userName}！</p>
          <p className="text-gray-500">选择您需要使用的功能模块</p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow cursor-pointer"
               onClick={() => navigate('/dashboard')}>
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-dashboard-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">工作台</h3>
            <p className="text-gray-600 text-center mb-4">查看工作概况、快速操作和最近活动</p>
            <div className="flex justify-center">
              <button className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer">
                进入工作台
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow cursor-pointer"
               onClick={() => navigate('/tool-detail?toolName=智能工作汇报助手&functionName=智能汇报生成&role=员工&user=' + encodeURIComponent(userName))}>
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-robot-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">智能助手</h3>
            <p className="text-gray-600 text-center mb-4">AI智能工作汇报助手，快速生成工作报告</p>
            <div className="flex justify-center">
              <button className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-6 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer">
                开始使用
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow cursor-pointer"
               onClick={() => navigate('/workspace')}>
            <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-window-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">智能工作台</h3>
            <p className="text-gray-600 text-center mb-4">嵌入式页面和AI助手集成工作环境</p>
            <div className="flex justify-center">
              <button className="bg-gradient-to-r from-green-500 to-teal-500 text-white px-6 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer">
                打开工作台
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow cursor-pointer"
               onClick={() => navigate('/sale-calendar')}>
            <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-calendar-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">销售日历</h3>
            <p className="text-gray-600 text-center mb-4">管理销售计划、跟进客户和业绩统计</p>
            <div className="flex justify-center">
              <button className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer">
                查看日历
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow cursor-pointer"
               onClick={() => navigate('/profile')}>
            <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-user-settings-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">个人资料</h3>
            <p className="text-gray-600 text-center mb-4">查看和编辑个人信息、账户设置</p>
            <div className="flex justify-center">
              <button className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-6 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer">
                管理资料
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow cursor-pointer"
               onClick={() => {
                 localStorage.removeItem('isLoggedIn');
                 localStorage.removeItem('userName');
                 localStorage.removeItem('userRole');
                 localStorage.removeItem('userPhone');
                 localStorage.removeItem('userProfile');
                 navigate('/login');
               }}>
            <div className="w-16 h-16 bg-gradient-to-r from-gray-500 to-gray-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-logout-box-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">退出登录</h3>
            <p className="text-gray-600 text-center mb-4">安全退出当前账户</p>
            <div className="flex justify-center">
              <button className="bg-gradient-to-r from-gray-500 to-gray-600 text-white px-6 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer">
                退出登录
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
